import React from 'react';
import { Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

export interface ShareButtonProps {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  label?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({
  onClick,
  disabled = false,
  variant = 'contained',
  size = 'medium',
  className = '',
  label = 'COMPARTILHAR',
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      startIcon={<ShareIcon />}
      className={className}
      sx={{
        fontWeight: 700,
        fontSize: '0.7rem',
        letterSpacing: '0.05em',
      }}
    >
      {label}
    </Button>
  );
};

export default ShareButton;
